module.exports = __webpack_public_path__ + "img/logo-original.e2e5a155.webp";